import DataSourceContainer from "../../../../components/formsAndTable/tables/dataTables/dataSource";

const DataSources = () => {
  return <DataSourceContainer />;
};

export default DataSources;
